export const locale = {
  lang: 'en',
  data: {
    RIGHTS_RESERVED: 'All Rights Reserved',
    PARTNERSHIP: 'Made by ',
  }
};
